import PropTypes from 'prop-types';
import React from 'react';
import {Modal, theme, Typography} from 'antd';
import parse from 'html-react-parser';
import {CloseIconDialog} from 'Components';
import {useCSContext} from 'Context/ContentStackContext';
import {useDialogScrollBar} from 'Hooks';

const TnCDialog = ({toggleTnDDialog, isDialogVisible, transactionDetails}) => {
  const {artifacts} = useCSContext();
  const {token}: any = theme.useToken();

  const {showScrollBar, isScrollbarVisible} = useDialogScrollBar(isDialogVisible);

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={isDialogVisible}
      onCancel={toggleTnDDialog}
      closable={false}
      footer={null}
      width="70%"
      style={{top: '15%'}}>
      <CloseIconDialog callback={toggleTnDDialog} image={artifacts.cross_icon} />
      <Typography.Title
        level={3}
        style={{color: token.colorPrimary, paddingTop: 32, marginBottom: 0}}>
        {transactionDetails.titleShort}
      </Typography.Title>
      <Typography.Title level={4} style={{marginTop: 8}}>
        Terms and Conditions
      </Typography.Title>

      <div
        onScroll={showScrollBar}
        className={isScrollbarVisible ? 'ast-scrollbar-visible' : 'ast-scrollbar-hidden'}
        style={{
          marginTop: 16,
          marginBottom: 24,
          marginRight: 24,
          maxHeight: '50vh',
          overflowY: 'auto',
        }}>
        <Typography.Text>{parse(transactionDetails.termsAndConditions)}</Typography.Text>
      </div>
      <style>{`
        .ast-scrollbar-hidden::-webkit-scrollbar-thumb { visibility: hidden; }
        .ast-scrollbar-visible::-webkit-scrollbar-thumb { visibility: visible; background-color: ${token.colorTextQuaternary}; border-radius: 15px; }
        .ast-scrollbar-hidden::-webkit-scrollbar, .ast-scrollbar-visible::-webkit-scrollbar { width: 0.3rem; }
      `}</style>
    </Modal>
  );
};

TnCDialog.propTypes = {
  toggleTnDDialog: PropTypes.func.isRequired,
  isDialogVisible: PropTypes.bool.isRequired,
  transactionDetails: PropTypes.object.isRequired,
};
export default TnCDialog;
